import React from "react";
import { useForm } from "react-hook-form";
import {
    Form,
    FormActions,
    FormFields,
    FormMultiselectDropdown,
    FormTextField,
    mapToDropdownOption
} from "sprint-common-web";

import { useCreateDeliveryEndpointForm } from "./useCreateSmartjogDeliveryEndpointForm";

export interface CreateDeliveryEndpointFormProps {
    onCancel(): void;
    onSubmit(): void;
}

export interface CreateDeliveryEndpointFormInputs {
    name: string;
    distributionListIds: string[];
}

export const CreateSmartjogDeliveryEndpointForm: React.VFC<CreateDeliveryEndpointFormProps> = ({
    onSubmit,
    onCancel
}: CreateDeliveryEndpointFormProps) => {
    const { distributionLists, addDeliveryEndpoint } = useCreateDeliveryEndpointForm();

    const { errors, control, formState, handleSubmit, reset } = useForm<CreateDeliveryEndpointFormInputs>({
        defaultValues: {
            name: "",
            distributionListIds: []
        },
        criteriaMode: "all"
    });

    const handleCreateDeliveryEndpoint = async (inputs: CreateDeliveryEndpointFormInputs) => {
        await addDeliveryEndpoint(inputs);
        onSubmit();
    };

    const handleCancelButtonClick = () => {
        reset();
        onCancel();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateDeliveryEndpoint)}>
            <FormFields>
                <FormTextField
                    label="Name"
                    control={control}
                    name="name"
                    errors={errors}
                    rules={{ required: "Enter name" }}
                />
                <FormMultiselectDropdown
                    label="Distribution Lists"
                    name="distributionListIds"
                    options={distributionLists.map((item) => mapToDropdownOption(item))}
                    control={control}
                    errors={errors}
                    rules={{ required: "Select 1 or more distribution list" }}
                    dependsOn={["typeKey"]}
                />
            </FormFields>
            <FormActions
                isLoading={formState.isSubmitting || formState.isValidating}
                onCancel={handleCancelButtonClick}
            />
        </Form>
    );
};
